import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { Button, useMediaQueryContext } from '@fourthwall/components';
import { DiscordIcon } from '@fourthwall/icons';
import { useCreatorIntegrationsQuery } from '../../../../../pages/Apps';
import { useVerifyDiscord } from '../../../../../pages/Apps/pages/AppsDiscordVerification';
import { Award } from '../../../components/Award/Award';
import { useCampaignStatus } from '../../../hooks/useCampaignStatus';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import joinDiscord from '../assets/join-discord.png';
const ID = 'joinDiscord';
export const useJoinDiscordRecommendation = () => {
    const media = useMediaQueryContext();
    const { creatorIntegrationsQuery } = useCreatorIntegrationsQuery();
    const { alreadyVerified, openVerificationLink } = useVerifyDiscord();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { activeIncentives } = useCampaignStatus();
    const incentive = activeIncentives.find((i) => i.recommendationId === ID);
    return {
        joinDiscordRecommendation: {
            id: ID,
            enabled: !alreadyVerified && recommendationsDismiss.joinDiscord.visible,
            isLoading: creatorIntegrationsQuery.isInitialLoading,
            suggestion: (React.createElement(Suggestion, { title: "Join our Discord community", description: "Connect with fellow creators in the Fourthwall community", content: React.createElement(Button, { fullWidth: !media.tablet, leftIcon: React.createElement(DiscordIcon, { height: 20, color: "#5865f2" }), label: "Verify and join Discord", analytics: "joinDiscord", size: "small", onClick: openVerificationLink }), imageUrl: joinDiscord, onDismiss: createOnDismiss(recommendationsDismiss.joinDiscord.dismiss), award: incentive ? (React.createElement(Award, { value: incentive.incentive.bonus.value, currency: "USD", text: "sample credit" })) : undefined })),
        },
    };
};
